module.exports = __webpack_public_path__ + "img/Size.ccbe22e9.svg";